import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldTextComponent } from './field-text.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FieldTextRenderImagePipe } from './field-text-render-image.pipe';



@NgModule({
  declarations: [
    FieldTextComponent,
    FieldTextRenderImagePipe
  ],
  exports: [
    FieldTextComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ]
})
export class FieldTextModule { }
